import { render, staticRenderFns } from "./Booth.vue?vue&type=template&id=0dd4c676&"
import script from "./Booth.vue?vue&type=script&lang=js&"
export * from "./Booth.vue?vue&type=script&lang=js&"
import style0 from "./Booth.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports